module.exports = __webpack_public_path__ + "static/img/witness-kids-4.c56e0c1b.png";